<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col class="Full-Course-Library-Title">
        Archived Users List
        </v-col>
      </v-row>
      <v-row style="margin-top: 20px">
        <v-col cols="12" sm="4">
          <v-card flat style="background-color: transparent">
            <v-card-actions>
              <v-text-field style="margin-top: 2px !important" class="search-box" placeholder="Search Users By Name Or Email"
                prepend-icon="fa-search" v-model="search" type="text" clearable clear-icon="fa-times"
                @click:clear="resetSearch" @keyup="applySearch"></v-text-field>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              :items="users"
              :footer-props="{
              'items-per-page-options': [5,10,15, 25, 50, 75, 100]
              }"
              v-show="!loading"
            >
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                      <v-btn v-on="on" outlined small class="mr-1 action-button action-button-txt" 
                          @click.prevent="restoreUser(item.id)">
                          <span>Restore</span>
                      </v-btn>
                  </template>
                  <span>Restore User</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                      <v-btn
                      v-on="on"
                      outlined
                      small
                      class="mr-1 action-button action-button-txt"
                      :to="'/admin/user-report/'+item.id" 
                      >
                          <span>Report</span>
                      </v-btn>
                  </template>
                  <span>View courses report for this user</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>

<script>
import { EventBus } from "@/event-bus.js";
import userAPI from "@/api/user.js";
import companyAPI from "@/api/company.js";
import ImportUsers from "@/components/admin/users/ImportUsers";
import LayoutBasic from "@/layouts/Dashboard";
import EditUser from "@/components/admin/users/Edit";
import CreateUser from "@/components/admin/users/Create";
import ImportUser from "@/components/admin/users/Import";
import ViewDetails from "@/components/admin/users/View";
import {
  WELCOME_QUEUED_MESSAGE,
  persistentToast,
  welcomeEmailErrorMessage,
} from "@/utils/welcomeEmail";
export default {
  name: "UsersAdmin",
  components: {
    LayoutBasic,
    ImportUsers,
  },
  data() {
    return {
      headers: [
        { text: "First Name", value: "first_name" },
        { text: "Surname", value: "last_name" },
        { text: "Email", value: "email" },
        { text: "Role Access", value: "role_name", sortable: false },
        { text: "Last Login", value: "last_login", sortable: false },
        { text: "Courses", value: "total_published_courses", sortable: false },
        { text: "Groups", value: "total_groups", sortable: false },
        { text: "Playlists", value: "total_channels", sortable: false },
        { text: "", value: "id", align: "end", sortable: false }
      ],
      users: [],
      search: "",
      searchParams: "",
      pagination: {},
      options: {},
      loading: false,
      enableMail: '',
      breatheId: false,
      created_date: "",
      confirmDelete: "Are you sure you wish to delete permanently this user?",
      confirmRestore: "Are you sure you wish to restore this user?",
      timer: null,
      // user ids with a welcome email request in flight
      sendingWelcome: {},
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    maxUsers: function() {
      return this.$store.getters.maxUsers; //20;
    },
    userLimit: function() {
      return this.serverItemsLength >= this.maxUsers ? true : false;
    },
    isBreatheEnabled: function() {
      return (this.created_date < "2021-04-30 00:00:00") ? true : false;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
    this.getCompany();
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    }
  },
  methods: {
    getUsers() {
      this.loading = true;
      userAPI.getArchivedClients(this.params, this.searchParams).then(resp => {
        this.users = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
        });
      },
    resetSearch() {
      this.searchParams = "";
      this.getUsers();
    },
    restoreUser(id) {
        this.$snotify.confirm(this.confirmRestore, {
            backdrop:0.3,                         
            buttons: [
               { text: "Cancel",className: 'toast-cancel-button' },
               { text: "Continue",className: 'toast-continue-button', action: toast => this.processRestoreUser(toast, id) }           
            ]
        });
    },
    processRestoreUser(toast, id) {
        this.$snotify.remove(toast.id);
        this.loading = true;
        userAPI.restoreUser(id).then(() => {
            this.getUsers();
            this.loading = false;
        }).catch(err => {
          this.$snotify.error(err.response.data.message);
          this.loading = false
        });
    },
    setEventBus() {
      EventBus.$on("USERS_UPDATED", payload => {
        this.params = payload;
        this.getUsers();
      });
    },
    applySearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.options.page = 1;
        this.createSearchParams();
      }, 1000);
    },
    createSearchParams() {
      this.searchParams = '';
      if (this.search) {
        this.searchParams =
          '&search=first_name:' + this.search + ';last_name:' + this.search+ ';email:' + this.search;
      }
      this.getUsers();
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params
        }
      });
    },
    showDetailsPanel(id) {
      this.$showPanel({
        component: ViewDetails,
        props: {
          id: id
        }
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateUser,
        props: {
          params: this.params
        }
      });
    },
    showUserImportPanel() {
      this.$showPanel({
        component: ImportUser,
        props: {
          params: this.params
        }
      });
    },
    enableDisableEmail(type) {
      this.loading = true;
      userAPI.enableDisableEmail(type).then((resp) => {
        this.enableMail = resp.data.data.enable_mail;
        this.loading = false;
      })
    },
    getCompany() {
      companyAPI.getCompanyById(this.$store.getters.user.company.data.id, '').then((resp) => {
        this.enableMail = resp.data.data.enable_mail;
        this.breatheId = resp.data.data.breathe_enabled;
        this.created_date = resp.data.data.created_at.date;
      })
    },
    sendWelcomeEmail(id) {
      // Not wired to a button on this page today; kept honest in case it is.
      // Same rules as the Users page: one request per person at a time, the
      // row marked as sent locally, and a refusal shown with its reason.
      if (this.sendingWelcome[id]) {
        return;
      }
      this.$set(this.sendingWelcome, id, true);
      userAPI.sendWelcomeEmail(id).then(() => {
        this.$delete(this.sendingWelcome, id);
        const row = this.users.find((user) => user.id === id);
        if (row) {
          this.$set(row, "is_mail_sent", 1);
        }
        this.$snotify.success(WELCOME_QUEUED_MESSAGE);
      }).catch((err) => {
        this.$delete(this.sendingWelcome, id);
        this.$snotify.error(welcomeEmailErrorMessage(err), persistentToast());
      });
    }
  }
};
</script>
